// extracted by mini-css-extract-plugin
export default {"group":"WebSearchToolbar__group--lDSnY","container":"WebSearchToolbar__container--l1PU6"};